import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ColorField } from '../../../commons/ui/fields/ColorField';
import { IEditMarkingToolBl } from '../../EditMarkingTool.bl';
import { IEditMarkingToolStore } from '../../EditMarkingTool.store';

export const ColorFieldContainer = observer((): ReactElement => {
  const bl = useInjection(IEditMarkingToolBl.$);
  const store = useInjection(IEditMarkingToolStore.$);

  const handleChange = (color: string): void => {
    bl.changeColor(color);
  };

  return (
    <ColorField
      color={store.color}
      onChangeColor={handleChange}
    />
  );
});
